import { createFileRoute, Link, useLocation } from '@tanstack/react-router';
import { SettingsShell, settingsItemClass } from '@/components/SettingsShell';
import { Bell, Bot, CreditCard, KeyRound, Users, Plug, ChartNoAxesColumn } from 'lucide-react';

export const Route = createFileRoute('/account')({
  component: AccountLayout,
});

// AB#594: Account is now a section with a persistent left sub-nav. Each item is
// its own child route rendered beside the menu (Team/Billing/Notifications...).
// Personal settings (profile, appearance) live under /user.
const NAV_ITEMS = [
  { to: '/account/connections', label: 'Connections & sharing', icon: Plug },
  { to: '/account/team', label: 'Team', icon: Users },
  { to: '/account/billing', label: 'Billing', icon: CreditCard },
  { to: '/account/notifications', label: 'Notifications', icon: Bell },
  { to: '/account/api-keys', label: 'API Keys', icon: KeyRound },
  { to: '/account/ai-keys', label: 'AI Provider Keys', icon: Bot },
  { to: '/account/ai-usage', label: 'AI usage', icon: ChartNoAxesColumn },
] as const;

function AccountLayout() {
  const path = useLocation().pathname;

  return (
    <SettingsShell navLabel="Account">
      {NAV_ITEMS.map(({ to, label, icon: Icon }) => {
        const active = path.startsWith(to);
        return (
          <Link key={to} to={to} search={to === '/account/connections' ? { category: 'social', ownership: 'mine', view: 'available' } : undefined} className={settingsItemClass(active)} aria-current={active ? 'page' : undefined}>
            <Icon className="size-4 shrink-0" />
            {label}
          </Link>
        );
      })}
    </SettingsShell>
  );
}
